import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class FarfetchGenderApiClient extends AdvancedApiClient {

    static entityType = "FarfetchGender"

    constructor(token, channelId) {
        super();

        this.setEntityType(FarfetchGenderApiClient.entityType)
            .setRoute("/api/v1/channel/{id}/farfetch/gender")
            .setRouteParam("id", channelId);
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}